import { createFileRoute } from "@tanstack/react-router";
import { SleepPage } from "@/modules/vital-signs/presentation/pages/SleepPage";

export const Route = createFileRoute("/_authenticated/sleep")({
  component: SleepPage,
});
